import React, { Fragment, useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from 'common/components/elements/buttons/primary';
import StoryBottomContent from 'common/components/modules/story-bottom-content';
import TimeSector from 'common/components/elements/time-sector';
import VideoContent from './video';
import ImageContent from './image';
import moment from 'moment';
import DateFormatter from 'common/utils/DateFormatter';
import { suggestedMembershipPlanPriceSelector } from 'sites/state/modules/common/selectors';
import CircleLoader from 'common/components/elements/loader/circle';
import { BlurhashCanvas } from "react-blurhash";
import { useSelector } from 'react-redux';
import './index.css'
import Icon from 'common/components/elements/icons';
import TruncateText from 'common/components/elements/truncate-text';
import { MediaButtonWrapper } from "common/components/modules/media";

const StoryCard = ({
   title,
   date,
   height,
   commentsCount,
   justify,
   hasAccess,
   src,
   type,
   onClickComment,
   onClickLike,
   onClickJoin,
   isAdmin,
   viewCount,
   likeCount,
   onClickOptions,
   openFullScreenCard,
   hideAfterMinutes,
   onImgLoad,
   lockedType,
   onClickLockedButton,
   isLiked,
   isAuthUsers,
   thumbnail,
   isMultiple,
   openStoryComments,
   identifier,
   suggestedMembershipPlanPrice,
   gotToSignUp,
   gotToSiteMembershipPlane,
   isShowBottomContent,
   isShowTopContent,
   onClickTip,
   id,
   onClickOpenTips,
   onClickSetId,
   data,
   totalTip,
   onShare,
   siteInfo,
   isLockedForSFW,
   videoCustomThumbnailIsSfw,
   isInsideModal,
   isChecked,
   onSelectItem,
}) => {
   const [isAutoPlay, setIsAutoPlay] = useState(false);
   const [isVisible, setIsVisible] = useState(false);
   const [imgLoad, setImgLoad] = useState(true);
   const [videoLoaded, setVideoLoaded] = useState(false)


   const callbackFunction = (entries) => {
      const [entry] = entries
      setIsVisible(entry.isIntersecting)
      if(screenWidth > 1024) {
         return;
      }
      if(!videoRef.current) return
      if(isVisible) {
         if(!!src && type === 'video') {
            setIsAutoPlay(true)
         }
      } else {
         if(!!src && type === 'video') {
            setIsAutoPlay(false)
         }
      }
   }
   const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
   }
   const screenWidth = useSelector(state => state.common.screenWidth);
   const videoRef = useRef();

   useEffect(() => {
      if(!videoRef.current) return;
      const observer = new IntersectionObserver(callbackFunction, options)
      if(videoRef.current) {
         observer.observe(videoRef.current?.childNodes[0]);
      }

      return () => {
         if(!videoRef.current) return;
         // eslint-disable-next-line react-hooks/exhaustive-deps
         if(videoRef.current) observer.unobserve(videoRef.current?.childNodes[0])
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [videoRef, options])


   let hasTimeOut = false;
   let timeSector = null
   let timeDifference = null
   if(!!hideAfterMinutes) {
      hasTimeOut = true
      const result = DateFormatter.storyDate(date, hideAfterMinutes)
      timeSector = result.sector
      timeDifference = result.time;
   }
   const storyDate = hideAfterMinutes ? timeDifference : 'Published ' + moment(`${ date }+00`).fromNow();

   const getVoiceIconRightPosition = () => {
      let right = 16;
      if(isShowBottomContent){
         if(isAdmin){
            right = right + 24
         } else {
            const element = document.querySelector('#story-button-right-content')
            if(element && element.offsetWidth){
               right = element.offsetWidth + 8
            }
         }
      }
      return right
   }
   return (
      <div
         ref={ videoRef }
         onMouseEnter={ () => {
            if(!!src && type === 'video' && screenWidth > 1024) {
               setIsAutoPlay(true)
            }
         } }
         onMouseLeave={ () => {
            if(!!src && type === 'video' && screenWidth > 1024) {
               setIsAutoPlay(false)
            }
         } }
         role='presentation'
         className={ cx(
            'focus-outline-card focus:outline-none h-full w-full'
         ) }
      >
         <div className={ `rounded-lg flex flex-col bg-secondary h-${ height } justify-${ justify } relative overflow-hidden` }>
            {/* Header start */}
            {
               isShowTopContent && (
                  <div style={ { zIndex: 12 } } className='flex flex-col px-2 pt-2 gap-2 items-start'>
                     {
                        title && (
                           <MediaButtonWrapper
                              isCenter={ false }
                           >
                              <TruncateText
                                 text={ title }
                                 // notranslate-content-title
                                 textClass='text-xl text-major-dark font-bold leading-tight select-none notranslate'
                                 textSize='20px'
                                 fontWeight='700'
                              />
                           </MediaButtonWrapper>
                        )
                     }
                     {
                        (hasTimeOut || isAdmin) && (
                           <MediaButtonWrapper isCenter={ false } className='inline-flex select-none items-center'>
                              {hasTimeOut && <TimeSector angle={ timeSector } />}
                              {isAdmin && <span className='text-sm text-major-dark'> {storyDate}</span>}
                           </MediaButtonWrapper>
                        )
                     }
                  </div>
               )
            }
            {
               !hasAccess ? (
                  <>
                     <div className='absolute top-0 w-full h-full left-0'>
                        <div className='w-full h-full relative'>
                           <BlurhashCanvas
                              hash={ src }
                              punch={ 1 }
                              className='w-full h-full rounded-lg object-cover'
                           />
                        </div>
                     </div>
                     <div
                        onClick={ (e) => {
                           e.stopPropagation()
                           onClickLockedButton()
                        } }
                        role='presentation'
                        className='rounded-lg w-full h-full backdrop-large absolute top-0 flex flex-col items-center justify-end bg-center bg-cover pb-12 cursor-pointer'
                        style={ {
                           backgroundColor: 'rgba(29, 41, 57, 0.3)',
                           backdropFilter: 'blur(4px)',
                        } }
                     >
                        <div
                           className='absolute top-0 w-full h-full flex items-center justify-center'
                        >
                           <Icon
                              size='[80px]'
                              name='lock'
                              className='text-[80px] text-[#FFFFFF99] dark:text-[#FFFFFF99] '
                              darkColor='#FFFFFF99'
                              style={ {
                                 opacity: '.9',
                              } }
                           />
                        </div>
                        <div
                           className='flex flex-col items-center'
                        >
                           {
                              lockedType === 'login' && (
                                 <>
                                    <span className='text-base font-bold text-major-dark-12 leading-tight text-center mt-12 select-none'>Already a member?</span>
                                    <div className='h-8 w-32 m-4 select-none'>
                                       <Button
                                          text='Sign in'
                                          padding='none'
                                          textSize='base'
                                          classNames='px-6 h-full'
                                          onClick={ (e) => {
                                             e.stopPropagation()
                                             onClickLockedButton()
                                          } }
                                          backgroundColor='transparent'
                                       />
                                    </div>
                                 </>
                              )
                           }
                        </div>
                     </div>
                  </>
               ) : (
                  <Fragment>
                     {type === 'image' && (
                        <div className='absolute z-10 rounded-lg w-full h-full overflow-hidden cursor-pointer'>

                           <div
                              className='w-full h-full absolute top-0 z-10'
                              style={ {
                                 background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.44) 0%, rgba(0, 0, 0, 0) 35.83%, rgba(0, 0, 0, 0) 80.32%, rgba(0, 0, 0, 0.4) 100%)',
                              } }
                              role='presentation'
                              onClick={ hasAccess && (() => openFullScreenCard(type)) }
                           />
                           <ImageContent
                              src={ src }
                              onImgLoad={ onImgLoad }
                              customStyle={ {
                                 background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.44) 0%, rgba(0, 0, 0, 0) 35.83%, rgba(0, 0, 0, 0) 80.32%, rgba(0, 0, 0, 0.4) 100%)',
                              } }
                           />
                        </div>
                     )}
                     {type === 'video' && (
                        <div
                           className='absolute z-10 rounded-lg w-full h-full overflow-hidden cursor-pointer'
                           role='presentation'
                           onClick={ hasAccess && (() => openFullScreenCard(type)) }
                        >
                           <div
                              className='w-full h-full absolute inset-0 z-10 flex items-center justify-center'
                           >
                              {!videoLoaded && (
                                 <div className='flex items-center w-full h-full relative'>
                                    {!!thumbnail && (
                                       <img
                                          src={ thumbnail }
                                          alt='thumbnail'
                                          className='w-full h-full object-cover'
                                          style={ {
                                             filter: videoCustomThumbnailIsSfw ? 'blur(32px)' : '',
                                          } }
                                       />
                                    )}
                                    <div className='absolute w-full h-full flex justify-center flex-col items-center'>
                                       <CircleLoader color='major-dark' />
                                    </div>
                                 </div>
                              )
                              }
                           </div>
                           {/* TODO video content features */}
                           <VideoContent
                              imgLoad={ imgLoad }
                              setImgLoad={ setImgLoad }
                              src={ src }
                              poster={ thumbnail }
                              setLoaded={ (bool) => setVideoLoaded(bool) }
                              setIsAutoPlay={ setIsAutoPlay }
                              isAutoPlay={ isAutoPlay }
                              voiceIconRightPosition={ getVoiceIconRightPosition() }
                              voiceButtonClassName={ isAdmin ? 'h-6 mb-2' : 'h-10 mb-2' }
                              isLockedForSFW={ isLockedForSFW }
                              videoCustomThumbnailIsSfw={ videoCustomThumbnailIsSfw }
                           />
                        </div>
                     )}
                  </Fragment>
               )
            }
            {/* Header end */}
            {/* Content start */}

            {/* Content end */}
            {/* Bottom start */}
            {/* { (hasAccess || showCommentButton) && ( */}
            {
               isShowBottomContent && (
                  <StoryBottomContent
                     commentsCount={ commentsCount }
                     onClickComment={ onClickComment }
                     onClickLike={ onClickLike }
                     isAdmin={ isAdmin }
                     viewCount={ viewCount }
                     likeCount={ likeCount }
                     isLiked={ isLiked }
                     onClickOptions={ () => onClickOptions(true, identifier) }
                     hasAccess={ hasAccess }
                     isAuthUsers={ isAuthUsers }
                     isMultiple={ isMultiple }
                     openStoryComments={ openStoryComments }
                     onClickTip={ onClickTip }
                     id={ id }
                     onClickOpenTips={ onClickOpenTips }
                     onClickSetId={ onClickSetId }
                     data={ data }
                     totalTip={ totalTip }
                     onShare={ onShare }
                     siteInfo={ siteInfo }
                     isInsideModal={ isInsideModal }
                     isChecked={ isChecked }
                     onSelectItem={ onSelectItem }
                  />
               )
            }
            {/* )} */}
            {/* Bottom end */}
         </div>
      </div>
   );
};

StoryCard.defaultProps = {
   height: 100,
   justify: 'between',
   isShowBottomContent: true,
   isShowTopContent: true,
};

StoryCard.propTypes = {
   title: PropTypes.string,
   src: PropTypes.any,
   date: PropTypes.string,
   height: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
   ]),
   commentsCount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
   ]),
   justify: PropTypes.oneOf([
      'between',
      'end',
      'center',
      'start',
      'around',
   ]),
   hasAccess: PropTypes.any,
   type: PropTypes.oneOf([
      'image',
      'video',
   ]),
   onClickComment: PropTypes.func,
   onClickLike: PropTypes.func,
   onClickOptions: PropTypes.func,
   onClickJoin: PropTypes.func,
   openFullScreenCard: PropTypes.func,
   onImgLoad: PropTypes.func,
   onClickLockedButton: PropTypes.func,
   gotToSignUp: PropTypes.func,
   gotToSiteMembershipPlane: PropTypes.func,
   openStoryComments: PropTypes.func,
   isAdmin: PropTypes.bool,
   likeCount: PropTypes.number,
   viewCount: PropTypes.number,
   hideAfterMinutes: PropTypes.number,
   lockedType: PropTypes.string,
   isLiked: PropTypes.bool,
   isAuthUsers: PropTypes.bool,
   isMultiple: PropTypes.bool,
   thumbnail: PropTypes.string,
   identifier: PropTypes.number,
   suggestedMembershipPlanPrice: PropTypes.number,
   isShowBottomContent: PropTypes.bool,
   isShowTopContent: PropTypes.bool,
   onClickTip: PropTypes.func,
   id: PropTypes.number,
   onClickOpenTips: PropTypes.func,
   onClickSetId: PropTypes.func,
   data: PropTypes.object,
   totalTip: PropTypes.number,
   onShare: PropTypes.func,
   siteInfo: PropTypes.object,
   isLockedForSFW: PropTypes.bool,
   videoCustomThumbnailIsSfw: PropTypes.bool,
   isInsideModal: PropTypes.bool,
   isChecked: PropTypes.bool,
   onSelectItem: PropTypes.func,
};

const mapStatesToProps = state => {
   return {
      suggestedMembershipPlanPrice: suggestedMembershipPlanPriceSelector(state),
   }
};

export default connect(mapStatesToProps)(StoryCard);
